import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Ship, MapPin, Zap, Award } from 'lucide-react';
export const TrustBar = () => {
  const {
    t
  } = useLanguage();
  const items = [{
    icon: Ship,
    textKey: 'trustbar.1'
  }, {
    icon: MapPin,
    textKey: 'trustbar.2'
  }, {
    icon: Zap,
    textKey: 'trustbar.3'
  }, {
    icon: Award,
    textKey: 'trustbar.4'
  }];
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <div className="relative bg-turquoise text-navy py-7 overflow-hidden" data-id="element-559" data-mp="5melcswaqdtz">
      {/* Animated wave background */}
      <motion.div aria-hidden className="absolute inset-0 opacity-20 pointer-events-none" animate={{
      backgroundPositionX: ['0%', '100%']
    }} transition={{
      duration: 30,
      repeat: Infinity,
      ease: 'linear'
    }} style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='40' viewBox='0 0 120 40'><path d='M0 20 Q 30 0 60 20 T 120 20' stroke='%230A1F44' stroke-width='2' fill='none' opacity='0.6'/></svg>\")",
      backgroundRepeat: 'repeat',
      backgroundSize: '120px 40px'
    }} data-id="element-560" data-mp="1aix9tog9v4v1" />

      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-30px'
    }} className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-561" data-mp="239oy7zr3ip7t">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-562" data-mp="287qigo09cukv">
          {items.map((entry, index) => {
          const Icon = entry.icon;
          return <motion.div key={index} variants={item} className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-3 group" data-id="element-563" data-mp="2k8fc59swq24e" data-mpi={index}>
                <motion.div whileHover={{
              rotate: -8,
              scale: 1.1
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} className="w-10 h-10 rounded-full bg-navy/10 flex items-center justify-center" data-id="element-564" data-mp="2tztf5rk2hk2a">
                  <Icon className="w-5 h-5" data-id="element-565" data-mp="3cxw280t216xg" />
                </motion.div>
                <span className="font-bold text-sm md:text-base leading-tight" data-id="element-566" data-mp="1dkrwrr1vm5na">
                  {t(entry.textKey)}
                </span>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </div>;
};